import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

function isResizeObserverError(msg: unknown, err?: Error): boolean {
  const s = typeof msg === 'string' ? msg : (msg && (msg as Error).message) || err?.message || '';
  return typeof s === 'string' && s.includes('ResizeObserver') && (s.includes('undelivered') || s.includes('limit exceeded'));
}

function installResizeObserverSuppression() {
  const current = window.onerror;
  window.onerror = function (
    message: string | Event,
    source?: string,
    lineno?: number,
    colno?: number,
    error?: Error
  ): boolean {
    const msg = typeof message === 'string' ? message : (message as ErrorEvent)?.message;
    if (isResizeObserverError(msg, error)) return true;
    if (typeof current === 'function') {
      return current.call(window, message, source ?? '', lineno ?? 0, colno ?? 0, error ?? new Error(String(message)));
    }
    return false;
  };
}

installResizeObserverSuppression();

// Re-apply after a tick so we wrap the overlay if it overwrote window.onerror
setTimeout(installResizeObserverSuppression, 0);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);